import { repository, baseURL } from '@/api/base'

export default {
  async postFiles(commonWorkId, fileTypeId, files) {
    const formData = new FormData()
    for (const file of files) formData.append('files', file, file.name)
    const { data } = await repository.post(baseURL + `/file/${commonWorkId}/${fileTypeId}`, formData)
    return data
  },

  async getFileList(commonWorkId) {
    const { data } = await repository.get(baseURL + `/file/byCommonWork/${commonWorkId}`)
    return data
  },

  async getFile(fileId, isWithCache = false) {
    const { data } = await repository.get(baseURL + `/file/${fileId}?isWithCache=${isWithCache}`, {
      responseType: 'blob'
    })
    return data
  },

  async removeFile(fileId) {
    const { data } = await repository.delete(baseURL + `/file/${fileId}`)
    return data
  }
}
